import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CignaIcon } from '@cigna/shared/angular/icon-ui';
import { CorrespondenceHistory } from '@cigna/chcp/claims/shared/util';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';

@Component({
  selector: 'cigna-correspondence-messages-list',
  templateUrl: './correspondence-messages-list.component.html',
  styleUrls: ['./correspondence-messages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CorrespondenceMessagesListComponent {
  @Input() messages: CorrespondenceHistory[];
  @Input() isImpersonator = false;
  @Input() maxHeight = 680;
  @Input() pageContext: 'claim' | 'precert';
  @Input() isReconEnh = false;

  @Output() openPdfEvent: EventEmitter<CorrespondenceHistory | string> =
    new EventEmitter();

  constructor(private analytics: ShellTrackHandlers) {}

  CignaIcon = CignaIcon;

  public trackByFunc(index: number, message: CorrespondenceHistory): string {
    return message.claimId ? message.claimId : '';
  }

  viewPDF(message: CorrespondenceHistory) {
    this.analytics.trackEventOther(
      {},
      'View PDF',
      this.pageContext === 'precert' ? 'acPA002' : 'acCD001',
      {
        eVar111: `view pdf:${message.subject}`,
        eVar120:
          this.pageContext === 'precert'
            ? 'precert-correspondence-history-pdf'
            : 'correspondence-history-pdf',
        eVar119: 'PC9TP-3472',
      },
    );

    this.openPdfEvent.emit(message);
  }
}
